import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';

/**
 * DO NOT CHANGE THIS GENERATED FILE MANUALLY
 */
var interaction___fullscreenEnter = function interaction___fullscreenEnter(_ref) {
  var id = _ref.id,
    _ref$svgAttrs = _ref.svgAttrs,
    svgAttrs = _ref$svgAttrs === void 0 ? {} : _ref$svgAttrs,
    title = _ref.title,
    variant = _ref.variant,
    size = _ref.size;
  var idTitle = id + "-title";
  if (variant === "outline" && size === 24) return "<svg ".concat(Object.entries(svgAttrs).map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
      key = _ref3[0],
      value = _ref3[1];
    return "".concat(key, "=\"").concat(value, "\"");
  }).join(" "), " id=\"").concat(id, "\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\">").concat(title ? "<title id=\"".concat(idTitle, "\">").concat(title, "</title>") : "", "<path d=\"M2 9h2V4h5V2H2v7zM15 2v2h5v5h2V2h-7zM20 20h-5v2h7v-7h-2v5zM4 15H2v7h7v-2H4v-5z\"/></svg>");
  if (variant === "solid" && size === 24) return "<svg ".concat(Object.entries(svgAttrs).map(function (_ref4) {
    var _ref5 = _slicedToArray(_ref4, 2),
      key = _ref5[0],
      value = _ref5[1];
    return "".concat(key, "=\"").concat(value, "\"");
  }).join(" "), " id=\"").concat(id, "\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\">").concat(title ? "<title id=\"".concat(idTitle, "\">").concat(title, "</title>") : "", "<path d=\"M2 10h4V6h4V2H2v8zM14 2v4h4v4h4V2h-8zM18 18h-4v4h8v-8h-4v4zM6 14H2v8h8v-4H6v-4z\"/></svg>");
  if (variant === "outline" && size === 48) return "<svg ".concat(Object.entries(svgAttrs).map(function (_ref6) {
    var _ref7 = _slicedToArray(_ref6, 2),
      key = _ref7[0],
      value = _ref7[1];
    return "".concat(key, "=\"").concat(value, "\"");
  }).join(" "), " id=\"").concat(id, "\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 48\">").concat(title ? "<title id=\"".concat(idTitle, "\">").concat(title, "</title>") : "", "<path d=\"M4 17h2V6h11V4H4v13zM31 4v2h11v11h2V4H31zM42 42H31v2h13V31h-2v11zM6 31H4v13h13v-2H6V31z\"/></svg>");
  if (variant === "solid" && size === 48) return "<svg ".concat(Object.entries(svgAttrs).map(function (_ref8) {
    var _ref9 = _slicedToArray(_ref8, 2),
      key = _ref9[0],
      value = _ref9[1];
    return "".concat(key, "=\"").concat(value, "\"");
  }).join(" "), " id=\"").concat(id, "\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 48\">").concat(title ? "<title id=\"".concat(idTitle, "\">").concat(title, "</title>") : "", "<path d=\"M4 18h4V8h10V4H4v14zM30 4v4h10v10h4V4H30zM40 40H30v4h14V30h-4v10zM8 30H4v14h14v-4H8V30z\"/></svg>");
  if (variant === "outline" && size === 96) return "<svg ".concat(Object.entries(svgAttrs).map(function (_ref10) {
    var _ref11 = _slicedToArray(_ref10, 2),
      key = _ref11[0],
      value = _ref11[1];
    return "".concat(key, "=\"").concat(value, "\"");
  }).join(" "), " id=\"").concat(id, "\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 96 96\">").concat(title ? "<title id=\"".concat(idTitle, "\">").concat(title, "</title>") : "", "<path d=\"M8 34h4V12h22V8H8v26zM62 8v4h22v22h4V8H62zM84 84H62v4h26V62h-4v22zM12 62H8v26h26v-4H12V62z\"/></svg>");
  if (variant === "solid" && size === 96) return "<svg ".concat(Object.entries(svgAttrs).map(function (_ref12) {
    var _ref13 = _slicedToArray(_ref12, 2),
      key = _ref13[0],
      value = _ref13[1];
    return "".concat(key, "=\"").concat(value, "\"");
  }).join(" "), " id=\"").concat(id, "\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 96 96\">").concat(title ? "<title id=\"".concat(idTitle, "\">").concat(title, "</title>") : "", "<path d=\"M8 36h8V16h20V8H8v28zM60 8v8h20v20h8V8H60zM80 80H60v8h28V60h-8v20zM16 60H8v28h28v-8H16V60z\"/></svg>");
};
interaction___fullscreenEnter.iconName = "interaction___fullscreenEnter";

export { interaction___fullscreenEnter };
